
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Category/[catId]",
      function () {
        return require("private-next-pages/Category/[catId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Category/[catId]"])
      });
    }
  